import { UseControllerProps, useController } from "react-hook-form";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { isValid } from "date-fns";
import { Grid } from "@mui/material";
import AppInformationText from "./AppInformationText";
import { CalendarPickerView } from "@mui/lab";

interface Props extends UseControllerProps {
  label: string;
  multiline?: boolean;
  rows?: number;
  type?: string;
  views?: CalendarPickerView[];
  opento?: string;
  format?: string;
  minDate?: Date;
  maxDate?: Date;
  information_text?: string;
  disabled?: boolean;
}

const AppDateTimePicker = (props: Props) => {
  const { field, fieldState } = useController({ ...props });

  return (
    <>
      <Grid container rowSpacing={4}>

        <Grid size={{ xs: 11 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              {...props}
              {...field}
              format="dd/MM/yyyy HH:mm"
              value={field.value || null}
              onChange={(newValue) => {
                if (isValid(newValue) || newValue === null) {
                  field.onChange(newValue);
                }
              }}
              slotProps={{
                textField: {
                  ...field,
                  fullWidth: true,
                  error: !!fieldState.error,
                  helperText: fieldState.error?.message,
                  className: 'rcsiTextField',
                  sx: props.disabled === true ? { backgroundColor: '#FAFAFA', color: '#858282' } : {},
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid size={{ xs: 1 }}>
          <AppInformationText information_text={props.information_text} />
        </Grid>

      </Grid>
    </>
  );
};

export default AppDateTimePicker;
